import { CertificateSummary, DqpDeviceType } from './dqp';
import { DeviceType, WaterManagementAreaType } from './types';

const DEFAULT_LIMIT = 10;

export class PageFilter {
	limit: number;
	offSet: number;

	constructor(limit = DEFAULT_LIMIT) {
		this.limit = limit;
		this.offSet = PageFilter.initialOffSet;
	}

	static initialOffSet = 0;
}

// TODO: if WEH API would get renamed as page.metadata.offset or [...].offSet – to harmonize both WEH and DQP APIs – then rename this as Page and remove above
export class PageDqpFilter {
	limit: number;
	offset: number;

	constructor(limit = DEFAULT_LIMIT) {
		this.limit = limit;
		this.offset = PageDqpFilter.initialOffset;
	}

	static initialOffset = 0;
}

export interface AuthorisationFilter {
	waterAccountId?: string;
}

type MdcStatusValue = `${CertificateSummary.status}`;
export type MdcStatusString = MdcStatusValue | `${MdcStatusValue},${MdcStatusValue}`;

export interface CertificateFilter {
	searchTerm?: string;
	mdcStatus?: MdcStatusString;
	reasonForInspection?: CertificateSummary.reasonForInspection;
	inspectionFrom?: string;
	inspectionTo?: string;
}

export interface MeterFilter {
	isApplicableForReadings?: boolean;
}

export interface DeviceFilter {
	isApplicableForReadings?: boolean;
	status?: 'Active' | 'InActive';
	statusreason?: string[];
	waterManagementArea?: WaterManagementAreaType;
}

export interface LocalDeviceFilter {
	type?: DeviceType.type[];
	deviceStatus?: DeviceType.deviceStatus[];
	waterManagementArea?: WaterManagementAreaType[];
}

export interface MakeModelFilter {
	deviceType?: DqpDeviceType;
}

export enum DeviceAreaOption {
	ALL = 'All devices',
	SUPPLEMENTED = 'Supplemented devices',
	UNSUPPLEMENTED = 'Unsupplemented devices',
}
